import styled, { css } from "styled-components";
import { above } from "./utils";
export const mainBackgroundColor = css`
  background: #1a202c;
`;
export const HeroSection = styled.div`
  height: 50vh;
  background: rgba(211, 211, 211, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const Input = styled.input`
  padding: 20px;
  border-radius: 5px;
`;
export const SuggestionCard = styled.a`
  width: 50%;
  text-decoration: none;
  border-radius: 5px;
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
  background: white;
  padding: 20px 20px;
  margin-bottom: 5px;
  font-size: 1.2rem;
`;
export const SearchBar = styled.div`
  display: flex;
  padding: 10px 30px;
  border-radius: 5px;
  width: 50%;
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.2);
  justify-content: start;
  background: white;
  color: black !important;
  align-items: center;
  margin-bottom: 5px;
  input:focus {
  }
  input {
    width: 95%;
    border: none;
    color: black;
    padding: 10px;
    outline: none;
    font-size: 1.2rem;
    font-family: "Rubik", sans-serif;
  }
  i {
    margin-right: 10px;
    float: left;
    width: 5%;
  }
`;
export const HR = styled.hr`
  padding: 0;
  border: none;
  height: 1px;
  margin: 20px 0;
  background-image: -webkit-linear-gradient(
    left,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
  background-image: -moz-linear-gradient(
    left,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
  background-image: -ms-linear-gradient(
    left,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
  background-image: -o-linear-gradient(
    left,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.75),
    rgba(0, 0, 0, 0)
  );
  color: #333;
  text-align: center;
`;
export const Backdrop = styled.div`
  background: linear-gradient(to right, rgba(0, 0, 0, 0.3), rgba(1, 0, 0, 0.3)),
    url(${props => `https://image.tmdb.org/t/p/w1280/${props.backdrop}`}),
    linear-gradient(to right, #0083b0, #00b4db); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  padding-top: 40vh;
  background-position: center center;
  ${above.small`
    background-position: none;
    padding-top: 50vh;
  `}
`;
